var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 209,
    viewBox: "0 0 201 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.683 9.56543H6.37695V200.872H197.683V9.56543Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5512 21.0439H17.8555V27.7397H24.5512V21.0439Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2465 21.0439H24.5508V27.7397H31.2465V21.0439Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9428 21.0439H31.2471V27.7397H37.9428V21.0439Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6381 21.0439H37.9424V27.7397H44.6381V21.0439Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3344 21.0439H44.6387V27.7397H51.3344V21.0439Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0297 21.0439H51.334V27.7397H58.0297V21.0439Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.725 21.0439H58.0293V27.7397H64.725V21.0439Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8129 21.0439H78.1172V27.7397H84.8129V21.0439Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 21.0439H98.2041V27.7397H104.9V21.0439Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M111.595 21.0439H104.899V27.7397H111.595V21.0439Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M118.291 21.0439H111.596V27.7397H118.291V21.0439Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M124.987 21.0439H118.291V27.7397H124.987V21.0439Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M131.682 21.0439H124.986V27.7397H131.682V21.0439Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M145.074 21.0439H138.378V27.7397H145.074V21.0439Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M151.77 21.0439H145.074V27.7397H151.77V21.0439Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M158.465 21.0439H151.77V27.7397H158.465V21.0439Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M165.161 21.0439H158.465V27.7397H165.161V21.0439Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M171.857 21.0439H165.161V27.7397H171.857V21.0439Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M178.552 21.0439H171.856V27.7397H178.552V21.0439Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M185.248 21.0439H178.553V27.7397H185.248V21.0439Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5512 27.7393H17.8555V34.435H24.5512V27.7393Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M64.725 27.7393H58.0293V34.435H64.725V27.7393Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1166 27.7393H71.4209V34.435H78.1166V27.7393Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2036 27.7393H91.5078V34.435H98.2036V27.7393Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 27.7393H98.2041V34.435H104.9V27.7393Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M111.595 27.7393H104.899V34.435H111.595V27.7393Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M118.291 27.7393H111.596V34.435H118.291V27.7393Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M124.987 27.7393H118.291V34.435H124.987V27.7393Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M145.074 27.7393H138.378V34.435H145.074V27.7393Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M185.248 27.7393H178.553V34.435H185.248V27.7393Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5512 34.4355H17.8555V41.1313H24.5512V34.4355Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9428 34.4355H31.2471V41.1313H37.9428V34.4355Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6381 34.4355H37.9424V41.1313H44.6381V34.4355Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3344 34.4355H44.6387V41.1313H51.3344V34.4355Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M64.725 34.4355H58.0293V41.1313H64.725V34.4355Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1166 34.4355H71.4209V41.1313H78.1166V34.4355Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8129 34.4355H78.1172V41.1313H84.8129V34.4355Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5082 34.4355H84.8125V41.1313H91.5082V34.4355Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2036 34.4355H91.5078V41.1313H98.2036V34.4355Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 34.4355H98.2041V41.1313H104.9V34.4355Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M131.682 34.4355H124.986V41.1313H131.682V34.4355Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M145.074 34.4355H138.378V41.1313H145.074V34.4355Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M158.465 34.4355H151.77V41.1313H158.465V34.4355Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M165.161 34.4355H158.465V41.1313H165.161V34.4355Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M171.857 34.4355H165.161V41.1313H171.857V34.4355Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M185.248 34.4355H178.553V41.1313H185.248V34.4355Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5512 41.1309H17.8555V47.8266H24.5512V41.1309Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9428 41.1309H31.2471V47.8266H37.9428V41.1309Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6381 41.1309H37.9424V47.8266H44.6381V41.1309Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3344 41.1309H44.6387V47.8266H51.3344V41.1309Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M64.725 41.1309H58.0293V47.8266H64.725V41.1309Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8129 41.1309H78.1172V47.8266H84.8129V41.1309Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5082 41.1309H84.8125V47.8266H91.5082V41.1309Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2036 41.1309H91.5078V47.8266H98.2036V41.1309Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M118.291 41.1309H111.596V47.8266H118.291V41.1309Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M124.987 41.1309H118.291V47.8266H124.987V41.1309Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M145.074 41.1309H138.378V47.8266H145.074V41.1309Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M158.465 41.1309H151.77V47.8266H158.465V41.1309Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M165.161 41.1309H158.465V47.8266H165.161V41.1309Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M171.857 41.1309H165.161V47.8266H171.857V41.1309Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M185.248 41.1309H178.553V47.8266H185.248V41.1309Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5512 47.8271H17.8555V54.5229H24.5512V47.8271Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9428 47.8271H31.2471V54.5229H37.9428V47.8271Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6381 47.8271H37.9424V54.5229H44.6381V47.8271Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3344 47.8271H44.6387V54.5229H51.3344V47.8271Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M64.725 47.8271H58.0293V54.5229H64.725V47.8271Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1166 47.8271H71.4209V54.5229H78.1166V47.8271Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M118.291 47.8271H111.596V54.5229H118.291V47.8271Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M124.987 47.8271H118.291V54.5229H124.987V47.8271Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M131.682 47.8271H124.986V54.5229H131.682V47.8271Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M145.074 47.8271H138.378V54.5229H145.074V47.8271Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M158.465 47.8271H151.77V54.5229H158.465V47.8271Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M165.161 47.8271H158.465V54.5229H165.161V47.8271Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M171.857 47.8271H165.161V54.5229H171.857V47.8271Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M185.248 47.8271H178.553V54.5229H185.248V47.8271Z",
    fill: "black"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5512 54.5225H17.8555V61.2182H24.5512V54.5225Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M64.725 54.5225H58.0293V61.2182H64.725V54.5225Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1166 54.5225H71.4209V61.2182H78.1166V54.5225Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8129 54.5225H78.1172V61.2182H84.8129V54.5225Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2036 54.5225H91.5078V61.2182H98.2036V54.5225Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M124.987 54.5225H118.291V61.2182H124.987V54.5225Z",
    fill: "black"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M131.682 54.5225H124.986V61.2182H131.682V54.5225Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M145.074 54.5225H138.378V61.2182H145.074V54.5225Z",
    fill: "black"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M185.248 54.5225H178.553V61.2182H185.248V54.5225Z",
    fill: "black"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5512 61.2178H17.8555V67.9135H24.5512V61.2178Z",
    fill: "black"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2465 61.2178H24.5508V67.9135H31.2465V61.2178Z",
    fill: "black"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9428 61.2178H31.2471V67.9135H37.9428V61.2178Z",
    fill: "black"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6381 61.2178H37.9424V67.9135H44.6381V61.2178Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3344 61.2178H44.6387V67.9135H51.3344V61.2178Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0297 61.2178H51.334V67.9135H58.0297V61.2178Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M64.725 61.2178H58.0293V67.9135H64.725V61.2178Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1166 61.2178H71.4209V67.9135H78.1166V61.2178Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5082 61.2178H84.8125V67.9135H91.5082V61.2178Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 61.2178H98.2041V67.9135H104.9V61.2178Z",
    fill: "black"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M118.291 61.2178H111.596V67.9135H118.291V61.2178Z",
    fill: "black"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M131.682 61.2178H124.986V67.9135H131.682V61.2178Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M145.074 61.2178H138.378V67.9135H145.074V61.2178Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M151.77 61.2178H145.074V67.9135H151.77V61.2178Z",
    fill: "black"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M158.465 61.2178H151.77V67.9135H158.465V61.2178Z",
    fill: "black"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M165.161 61.2178H158.465V67.9135H165.161V61.2178Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M171.857 61.2178H165.161V67.9135H171.857V61.2178Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M178.552 61.2178H171.856V67.9135H178.552V61.2178Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M185.248 61.2178H178.553V67.9135H185.248V61.2178Z",
    fill: "black"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1166 67.9141H71.4209V74.6098H78.1166V67.9141Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8129 67.9141H78.1172V74.6098H84.8129V67.9141Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 67.9141H98.2041V74.6098H104.9V67.9141Z",
    fill: "black"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M131.682 67.9141H124.986V74.6098H131.682V67.9141Z",
    fill: "black"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5512 74.6094H17.8555V81.3051H24.5512V74.6094Z",
    fill: "black"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2465 74.6094H24.5508V81.3051H31.2465V74.6094Z",
    fill: "black"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6381 74.6094H37.9424V81.3051H44.6381V74.6094Z",
    fill: "black"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M64.725 74.6094H58.0293V81.3051H64.725V74.6094Z",
    fill: "black"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4213 74.6094H64.7256V81.3051H71.4213V74.6094Z",
    fill: "black"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5082 74.6094H84.8125V81.3051H91.5082V74.6094Z",
    fill: "black"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M111.595 74.6094H104.899V81.3051H111.595V74.6094Z",
    fill: "black"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M118.291 74.6094H111.596V81.3051H118.291V74.6094Z",
    fill: "black"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M145.074 74.6094H138.378V81.3051H145.074V74.6094Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M151.77 74.6094H145.074V81.3051H151.77V74.6094Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M158.465 74.6094H151.77V81.3051H158.465V74.6094Z",
    fill: "black"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M171.857 74.6094H165.161V81.3051H171.857V74.6094Z",
    fill: "black"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M178.552 74.6094H171.856V81.3051H178.552V74.6094Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5512 81.3057H17.8555V88.0014H24.5512V81.3057Z",
    fill: "black"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3344 81.3057H44.6387V88.0014H51.3344V81.3057Z",
    fill: "black"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4213 81.3057H64.7256V88.0014H71.4213V81.3057Z",
    fill: "black"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1166 81.3057H71.4209V88.0014H78.1166V81.3057Z",
    fill: "black"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5082 81.3057H84.8125V88.0014H91.5082V81.3057Z",
    fill: "black"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2036 81.3057H91.5078V88.0014H98.2036V81.3057Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M111.595 81.3057H104.899V88.0014H111.595V81.3057Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M131.682 81.3057H124.986V88.0014H131.682V81.3057Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M145.074 81.3057H138.378V88.0014H145.074V81.3057Z",
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M185.248 81.3057H178.553V88.0014H185.248V81.3057Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5512 88.001H17.8555V94.6967H24.5512V88.001Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2465 88.001H24.5508V94.6967H31.2465V88.001Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9428 88.001H31.2471V94.6967H37.9428V88.001Z",
    fill: "black"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3344 88.001H44.6387V94.6967H51.3344V88.001Z",
    fill: "black"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0297 88.001H51.334V94.6967H58.0297V88.001Z",
    fill: "black"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M64.725 88.001H58.0293V94.6967H64.725V88.001Z",
    fill: "black"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8129 88.001H78.1172V94.6967H84.8129V88.001Z",
    fill: "black"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5082 88.001H84.8125V94.6967H91.5082V88.001Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M111.595 88.001H104.899V94.6967H111.595V88.001Z",
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M131.682 88.001H124.986V94.6967H131.682V88.001Z",
    fill: "black"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M138.378 88.001H131.683V94.6967H138.378V88.001Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M145.074 88.001H138.378V94.6967H145.074V88.001Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M178.552 88.001H171.856V94.6967H178.552V88.001Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M185.248 88.001H178.553V94.6967H185.248V88.001Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2465 94.6963H24.5508V101.392H31.2465V94.6963Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9428 94.6963H31.2471V101.392H37.9428V94.6963Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3344 94.6963H44.6387V101.392H51.3344V94.6963Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M111.595 94.6963H104.899V101.392H111.595V94.6963Z",
    fill: "black"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M124.987 94.6963H118.291V101.392H124.987V94.6963Z",
    fill: "black"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M131.682 94.6963H124.986V101.392H131.682V94.6963Z",
    fill: "black"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M138.378 94.6963H131.683V101.392H138.378V94.6963Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M145.074 94.6963H138.378V101.392H145.074V94.6963Z",
    fill: "black"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M158.465 94.6963H151.77V101.392H158.465V94.6963Z",
    fill: "black"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2465 101.393H24.5508V108.088H31.2465V101.393Z",
    fill: "black"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6381 101.393H37.9424V108.088H44.6381V101.393Z",
    fill: "black"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3344 101.393H44.6387V108.088H51.3344V101.393Z",
    fill: "black"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0297 101.393H51.334V108.088H58.0297V101.393Z",
    fill: "black"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M64.725 101.393H58.0293V108.088H64.725V101.393Z",
    fill: "black"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1166 101.393H71.4209V108.088H78.1166V101.393Z",
    fill: "black"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 101.393H98.2041V108.088H104.9V101.393Z",
    fill: "black"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M111.595 101.393H104.899V108.088H111.595V101.393Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M124.987 101.393H118.291V108.088H124.987V101.393Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M131.682 101.393H124.986V108.088H131.682V101.393Z",
    fill: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M145.074 101.393H138.378V108.088H145.074V101.393Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M151.77 101.393H145.074V108.088H151.77V101.393Z",
    fill: "black"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M165.161 101.393H158.465V108.088H165.161V101.393Z",
    fill: "black"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M178.552 101.393H171.856V108.088H178.552V101.393Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M185.248 101.393H178.553V108.088H185.248V101.393Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3344 108.088H44.6387V114.784H51.3344V108.088Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5082 108.088H84.8125V114.784H91.5082V108.088Z",
    fill: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2036 108.088H91.5078V114.784H98.2036V108.088Z",
    fill: "black"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 108.088H98.2041V114.784H104.9V108.088Z",
    fill: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M118.291 108.088H111.596V114.784H118.291V108.088Z",
    fill: "black"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M131.682 108.088H124.986V114.784H131.682V108.088Z",
    fill: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M138.378 108.088H131.683V114.784H138.378V108.088Z",
    fill: "black"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M145.074 108.088H138.378V114.784H145.074V108.088Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M151.77 108.088H145.074V114.784H151.77V108.088Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M165.161 108.088H158.465V114.784H165.161V108.088Z",
    fill: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M171.857 108.088H165.161V114.784H171.857V108.088Z",
    fill: "black"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M185.248 108.088H178.553V114.784H185.248V108.088Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5512 114.784H17.8555V121.48H24.5512V114.784Z",
    fill: "black"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9428 114.784H31.2471V121.48H37.9428V114.784Z",
    fill: "black"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6381 114.784H37.9424V121.48H44.6381V114.784Z",
    fill: "black"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3344 114.784H44.6387V121.48H51.3344V114.784Z",
    fill: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0297 114.784H51.334V121.48H58.0297V114.784Z",
    fill: "black"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M64.725 114.784H58.0293V121.48H64.725V114.784Z",
    fill: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4213 114.784H64.7256V121.48H71.4213V114.784Z",
    fill: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1166 114.784H71.4209V121.48H78.1166V114.784Z",
    fill: "black"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8129 114.784H78.1172V121.48H84.8129V114.784Z",
    fill: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 114.784H98.2041V121.48H104.9V114.784Z",
    fill: "black"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M118.291 114.784H111.596V121.48H118.291V114.784Z",
    fill: "black"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M151.77 114.784H145.074V121.48H151.77V114.784Z",
    fill: "black"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M158.465 114.784H151.77V121.48H158.465V114.784Z",
    fill: "black"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M171.857 114.784H165.161V121.48H171.857V114.784Z",
    fill: "black"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M185.248 114.784H178.553V121.48H185.248V114.784Z",
    fill: "black"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2465 121.479H24.5508V128.175H31.2465V121.479Z",
    fill: "black"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1166 121.479H71.4209V128.175H78.1166V121.479Z",
    fill: "black"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5082 121.479H84.8125V128.175H91.5082V121.479Z",
    fill: "black"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 121.479H98.2041V128.175H104.9V121.479Z",
    fill: "black"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M111.595 121.479H104.899V128.175H111.595V121.479Z",
    fill: "black"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M138.378 121.479H131.683V128.175H138.378V121.479Z",
    fill: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M145.074 121.479H138.378V128.175H145.074V121.479Z",
    fill: "black"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M165.161 121.479H158.465V128.175H165.161V121.479Z",
    fill: "black"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M178.552 121.479H171.856V128.175H178.552V121.479Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5512 128.175H17.8555V134.871H24.5512V128.175Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2465 128.175H24.5508V134.871H31.2465V128.175Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0297 128.175H51.334V134.871H58.0297V128.175Z",
    fill: "black"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M64.725 128.175H58.0293V134.871H64.725V128.175Z",
    fill: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4213 128.175H64.7256V134.871H71.4213V128.175Z",
    fill: "black"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1166 128.175H71.4209V134.871H78.1166V128.175Z",
    fill: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8129 128.175H78.1172V134.871H84.8129V128.175Z",
    fill: "black"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2036 128.175H91.5078V134.871H98.2036V128.175Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M111.595 128.175H104.899V134.871H111.595V128.175Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M118.291 128.175H111.596V134.871H118.291V128.175Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M131.682 128.175H124.986V134.871H131.682V128.175Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M138.378 128.175H131.683V134.871H138.378V128.175Z",
    fill: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M145.074 128.175H138.378V134.871H145.074V128.175Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M151.77 128.175H145.074V134.871H151.77V128.175Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M158.465 128.175H151.77V134.871H158.465V128.175Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M165.161 128.175H158.465V134.871H165.161V128.175Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M171.857 128.175H165.161V134.871H171.857V128.175Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1166 134.871H71.4209V141.567H78.1166V134.871Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8129 134.871H78.1172V141.567H84.8129V134.871Z",
    fill: "black"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M118.291 134.871H111.596V141.567H118.291V134.871Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M131.682 134.871H124.986V141.567H131.682V134.871Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M158.465 134.871H151.77V141.567H158.465V134.871Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M165.161 134.871H158.465V141.567H165.161V134.871Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M171.857 134.871H165.161V141.567H171.857V134.871Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M185.248 134.871H178.553V141.567H185.248V134.871Z",
    fill: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5512 141.566H17.8555V148.262H24.5512V141.566Z",
    fill: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2465 141.566H24.5508V148.262H31.2465V141.566Z",
    fill: "black"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9428 141.566H31.2471V148.262H37.9428V141.566Z",
    fill: "black"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6381 141.566H37.9424V148.262H44.6381V141.566Z",
    fill: "black"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3344 141.566H44.6387V148.262H51.3344V141.566Z",
    fill: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0297 141.566H51.334V148.262H58.0297V141.566Z",
    fill: "black"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M64.725 141.566H58.0293V148.262H64.725V141.566Z",
    fill: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1166 141.566H71.4209V148.262H78.1166V141.566Z",
    fill: "black"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8129 141.566H78.1172V148.262H84.8129V141.566Z",
    fill: "black"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5082 141.566H84.8125V148.262H91.5082V141.566Z",
    fill: "black"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M111.595 141.566H104.899V148.262H111.595V141.566Z",
    fill: "black"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M124.987 141.566H118.291V148.262H124.987V141.566Z",
    fill: "black"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M131.682 141.566H124.986V148.262H131.682V141.566Z",
    fill: "black"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M145.074 141.566H138.378V148.262H145.074V141.566Z",
    fill: "black"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M158.465 141.566H151.77V148.262H158.465V141.566Z",
    fill: "black"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M178.552 141.566H171.856V148.262H178.552V141.566Z",
    fill: "black"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M185.248 141.566H178.553V148.262H185.248V141.566Z",
    fill: "black"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5512 148.263H17.8555V154.958H24.5512V148.263Z",
    fill: "black"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M64.725 148.263H58.0293V154.958H64.725V148.263Z",
    fill: "black"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8129 148.263H78.1172V154.958H84.8129V148.263Z",
    fill: "black"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2036 148.263H91.5078V154.958H98.2036V148.263Z",
    fill: "black"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M111.595 148.263H104.899V154.958H111.595V148.263Z",
    fill: "black"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M131.682 148.263H124.986V154.958H131.682V148.263Z",
    fill: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M158.465 148.263H151.77V154.958H158.465V148.263Z",
    fill: "black"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M165.161 148.263H158.465V154.958H165.161V148.263Z",
    fill: "black"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M171.857 148.263H165.161V154.958H171.857V148.263Z",
    fill: "black"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5512 154.958H17.8555V161.654H24.5512V154.958Z",
    fill: "black"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9428 154.958H31.2471V161.654H37.9428V154.958Z",
    fill: "black"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6381 154.958H37.9424V161.654H44.6381V154.958Z",
    fill: "black"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3344 154.958H44.6387V161.654H51.3344V154.958Z",
    fill: "black"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M64.725 154.958H58.0293V161.654H64.725V154.958Z",
    fill: "black"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2036 154.958H91.5078V161.654H98.2036V154.958Z",
    fill: "black"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 154.958H98.2041V161.654H104.9V154.958Z",
    fill: "black"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M118.291 154.958H111.596V161.654H118.291V154.958Z",
    fill: "black"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M131.682 154.958H124.986V161.654H131.682V154.958Z",
    fill: "black"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M138.378 154.958H131.683V161.654H138.378V154.958Z",
    fill: "black"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M145.074 154.958H138.378V161.654H145.074V154.958Z",
    fill: "black"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M151.77 154.958H145.074V161.654H151.77V154.958Z",
    fill: "black"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M158.465 154.958H151.77V161.654H158.465V154.958Z",
    fill: "black"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M185.248 154.958H178.553V161.654H185.248V154.958Z",
    fill: "black"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5512 161.653H17.8555V168.349H24.5512V161.653Z",
    fill: "black"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9428 161.653H31.2471V168.349H37.9428V161.653Z",
    fill: "black"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6381 161.653H37.9424V168.349H44.6381V161.653Z",
    fill: "black"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3344 161.653H44.6387V168.349H51.3344V161.653Z",
    fill: "black"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M64.725 161.653H58.0293V168.349H64.725V161.653Z",
    fill: "black"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1166 161.653H71.4209V168.349H78.1166V161.653Z",
    fill: "black"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5082 161.653H84.8125V168.349H91.5082V161.653Z",
    fill: "black"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2036 161.653H91.5078V168.349H98.2036V161.653Z",
    fill: "black"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 161.653H98.2041V168.349H104.9V161.653Z",
    fill: "black"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M111.595 161.653H104.899V168.349H111.595V161.653Z",
    fill: "black"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M124.987 161.653H118.291V168.349H124.987V161.653Z",
    fill: "black"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M131.682 161.653H124.986V168.349H131.682V161.653Z",
    fill: "black"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M158.465 161.653H151.77V168.349H158.465V161.653Z",
    fill: "black"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M171.857 161.653H165.161V168.349H171.857V161.653Z",
    fill: "black"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5512 168.35H17.8555V175.045H24.5512V168.35Z",
    fill: "black"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9428 168.35H31.2471V175.045H37.9428V168.35Z",
    fill: "black"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6381 168.35H37.9424V175.045H44.6381V168.35Z",
    fill: "black"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3344 168.35H44.6387V175.045H51.3344V168.35Z",
    fill: "black"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M64.725 168.35H58.0293V175.045H64.725V168.35Z",
    fill: "black"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5082 168.35H84.8125V175.045H91.5082V168.35Z",
    fill: "black"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2036 168.35H91.5078V175.045H98.2036V168.35Z",
    fill: "black"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 168.35H98.2041V175.045H104.9V168.35Z",
    fill: "black"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M111.595 168.35H104.899V175.045H111.595V168.35Z",
    fill: "black"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M118.291 168.35H111.596V175.045H118.291V168.35Z",
    fill: "black"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M138.378 168.35H131.683V175.045H138.378V168.35Z",
    fill: "black"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M158.465 168.35H151.77V175.045H158.465V168.35Z",
    fill: "black"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M165.161 168.35H158.465V175.045H165.161V168.35Z",
    fill: "black"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M171.857 168.35H165.161V175.045H171.857V168.35Z",
    fill: "black"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M185.248 168.35H178.553V175.045H185.248V168.35Z",
    fill: "black"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5512 175.045H17.8555V181.741H24.5512V175.045Z",
    fill: "black"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M64.725 175.045H58.0293V181.741H64.725V175.045Z",
    fill: "black"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1166 175.045H71.4209V181.741H78.1166V175.045Z",
    fill: "black"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5082 175.045H84.8125V181.741H91.5082V175.045Z",
    fill: "black"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2036 175.045H91.5078V181.741H98.2036V175.045Z",
    fill: "black"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M104.9 175.045H98.2041V181.741H104.9V175.045Z",
    fill: "black"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M111.595 175.045H104.899V181.741H111.595V175.045Z",
    fill: "black"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M124.987 175.045H118.291V181.741H124.987V175.045Z",
    fill: "black"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M131.682 175.045H124.986V181.741H131.682V175.045Z",
    fill: "black"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M165.161 175.045H158.465V181.741H165.161V175.045Z",
    fill: "black"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5512 181.741H17.8555V188.437H24.5512V181.741Z",
    fill: "black"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2465 181.741H24.5508V188.437H31.2465V181.741Z",
    fill: "black"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9428 181.741H31.2471V188.437H37.9428V181.741Z",
    fill: "black"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6381 181.741H37.9424V188.437H44.6381V181.741Z",
    fill: "black"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3344 181.741H44.6387V188.437H51.3344V181.741Z",
    fill: "black"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0297 181.741H51.334V188.437H58.0297V181.741Z",
    fill: "black"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M64.725 181.741H58.0293V188.437H64.725V181.741Z",
    fill: "black"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1166 181.741H71.4209V188.437H78.1166V181.741Z",
    fill: "black"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8129 181.741H78.1172V188.437H84.8129V181.741Z",
    fill: "black"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5082 181.741H84.8125V188.437H91.5082V181.741Z",
    fill: "black"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2036 181.741H91.5078V188.437H98.2036V181.741Z",
    fill: "black"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M118.291 181.741H111.596V188.437H118.291V181.741Z",
    fill: "black"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M124.987 181.741H118.291V188.437H124.987V181.741Z",
    fill: "black"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M131.682 181.741H124.986V188.437H131.682V181.741Z",
    fill: "black"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M138.378 181.741H131.683V188.437H138.378V181.741Z",
    fill: "black"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M151.77 181.741H145.074V188.437H151.77V181.741Z",
    fill: "black"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M178.552 181.741H171.856V188.437H178.552V181.741Z",
    fill: "black"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M185.248 181.741H178.553V188.437H185.248V181.741Z",
    fill: "black"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M201 208.971H123.298V199.998H192.028V131.269H201V208.971Z",
    fill: "#FF5A00"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7022 208.971H0V131.269H8.97254V199.998H77.7022V208.971Z",
    fill: "#FF5A00"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97254 77.7022H0V0H77.7022V8.97254H8.97254V77.7022Z",
    fill: "#FF5A00"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M201 77.7022H192.028V8.97254H123.298V0H201V77.7022Z",
    fill: "#FF5A00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/QR.2781a5dc943b6f60bb80c02b6a0b084c.svg";
export { ForwardRef as ReactComponent };